module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('discount-blank-form', {
    attrs: {
      "submit-label": "Добавить скидку",
      "discount": _vm.discount,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processDiscountForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-911b49d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/discount/DiscountAddForm.vue
// module id = 685
// module chunks = 0